// 🔧 content_step.js
// ✅ Purpose: Content Seeder pipeline step
// ✅ Features:
// - Executes Content Seeder
// - Writes public event content settings
// - Updates DemoContext with content result
// - Keeps content seeding modular
// - Fully block-commented for clarity and future devs

import {
  createPipelineStepSuccess,
} from "../pipeline_step";

import {
  seedContentShell,
} from "../../seeders/event/content_seeder";

export const createContentStep = () => ({
  name: "content_seeder",

  label: "Content Seeder",

  run: async (context) => {
    const result =
      await seedContentShell(context);

    return createPipelineStepSuccess({
      step: "content_seeder",

      label: "Content Seeder",

      created:
        result?.createdCount || 0,

      message:
        result?.message,

      metadata:
        result,

      startedAt:
        context.startedAt,
    });
  },

  afterSuccess: ({
    result,
    sharedContext,
  }) => {
    sharedContext.contentResult =
      result?.metadata || null;
  },
});